<div class="loading">
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 104 104"
    xml:space="preserve"
  >
    <style type="text/css">
      @-webkit-keyframes blink {
        0% {
          fill: #f68b32;
        }
        100% {
          fill: #d15420;
        }
      }

      @-moz-keyframes blink {
        0% {
          fill: #f68b32;
        }
        100% {
          fill: #d15420;
        }
      }

      @-o-keyframes blink {
        0% {
          fill: #f68b32;
        }
        100% {
          fill: #d15420;
        }
      }

      @keyframes blink {
        0% {
          fill: #f68b32;
        }
        100% {
          fill: #d15420;
        }
      }

      .blink {
        fill: #f36f23;
        -webkit-animation: blink 1s infinite;
        /* Safari 4+ */
        -moz-animation: blink 1s infinite;
        /* Fx 5+ */
        -o-animation: blink 1s infinite;
        /* Opera 12+ */
        animation: blink 1s infinite;
        /* IE 10+, Fx 29+ */
      }

      .t7 {
        -webkit-animation-delay: 125ms;
        animation-delay: 125ms;
      }

      .t6 {
        -webkit-animation-delay: 250ms;
        animation-delay: 250ms;
      }

      .t5 {
        -webkit-animation-delay: 375ms;
        animation-delay: 375ms;
      }

      .t4 {
        -webkit-animation-delay: 500ms;
        animation-delay: 500ms;
      }

      .t3 {
        -webkit-animation-delay: 625ms;
        animation-delay: 625ms;
      }

      .t2 {
        -webkit-animation-delay: 750ms;
        animation-delay: 750ms;
      }

      .t1 {
        -webkit-animation-delay: 875ms;
        animation-delay: 875ms;
      }
    </style>
    <title>Loading...</title>
    <desc>Loading Spinner</desc>
    <g id="Horizontal-No-Tagline">
      <g id="Color-Horizontal" transform="translate(1.000000, 0.000000)">
        <g id="Allegion-A" transform="translate(418.000000, 0.000000)">
          <path
            id="Combined-Shape-Copy-4"
            class="t1 blink"
            d="M-315,103.8V72h-31.9c-0.1,0.8-0.1,1.7-0.1,2.5c0,16.3,13,29.5,29,29.5
              C-317,104-316,103.9-315,103.8z"
          />

          <rect
            id="Rectangle-6-Copy-4"
            x="-347"
            y="36"
            class="t2 blink"
            width="32"
            height="32"
          />

          <path
            id="Combined-Shape-Copy-2"
            class="t3 blink"
            d="M-347,0.2V32h31.9c0.1-0.8,0.1-1.7,0.1-2.5C-315,13.2-328,0-344,0
              C-345,0-346,0.1-347,0.2z"
          />

          <rect
            id="Rectangle-6"
            x="-383"
            class="t4 blink"
            width="32"
            height="32"
          />

          <path
            id="Combined-Shape"
            class="t5 blink"
            d="M-387,0.2V32h-31.9c-0.1-0.8-0.1-1.7-0.1-2.5C-419,13.2-406,0-390,0
              C-389,0-388,0.1-387,0.2z"
          />

          <rect
            id="Rectangle-6-Copy-2"
            x="-419"
            y="36"
            class="t6 blink"
            width="32"
            height="32"
          />

          <path
            id="Combined-Shape-Copy"
            class="t7 blink"
            d="M-387,103.8V72h-31.9c-0.1,0.8-0.1,1.7-0.1,2.5c0,16.3,13,29.5,29,29.5
              C-389,104-388,103.9-387,103.8z"
          />

          <path
            id="Combined-Shape-Copy-3"
            class="t8 blink"
            d="M-383,103.8V72h31.9c0.1,0.8,0.1,1.7,0.1,2.5c0,16.3-13,29.5-29,29.5
              C-381,104-382,103.9-383,103.8z"
          />
        </g>
      </g>
    </g>
  </svg>
  <div class="title"><h5></h5></div>
  <div class="content"><h6>Loading...</h6></div>
</div>
